/**
 * @generated SignedSource<<ec902800a3e915466bcb9e160508217e>>
 * @flow
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type TeamPipelineDeleteInput = {|
  clientMutationId?: ?string,
  force?: ?boolean,
  id: string,
|};
export type PipelinesTeamDeleteMutation$variables = {|
  input: TeamPipelineDeleteInput,
|};
export type PipelinesTeamDeleteMutation$data = {|
  +teamPipelineDelete: ?{|
    +deletedTeamPipelineID: string,
    +team: ?{|
      +id: string,
      +pipelines: ?{|
        +count: number,
      |},
    |},
  |},
|};
export type PipelinesTeamDeleteMutation = {|
  response: PipelinesTeamDeleteMutation$data,
  variables: PipelinesTeamDeleteMutation$variables,
|};
*/

var node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "TeamPipelineDeletePayload",
    "kind": "LinkedField",
    "name": "teamPipelineDelete",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deletedTeamPipelineID",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Team",
        "kind": "LinkedField",
        "name": "team",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "TeamPipelineConnection",
            "kind": "LinkedField",
            "name": "pipelines",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "count",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PipelinesTeamDeleteMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PipelinesTeamDeleteMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "f6c0af7e9e9fe4a8e61b074ce63d1114",
    "id": null,
    "metadata": {},
    "name": "PipelinesTeamDeleteMutation",
    "operationKind": "mutation",
    "text": "mutation PipelinesTeamDeleteMutation(\n  $input: TeamPipelineDeleteInput!\n) {\n  teamPipelineDelete(input: $input) {\n    deletedTeamPipelineID\n    team {\n      id\n      pipelines {\n        count\n      }\n    }\n  }\n}\n"
  }
};
})();

(node/*: any*/).hash = "b26401233d0aa077d3ea326ee341ccd0";

module.exports = ((node/*: any*/)/*: Mutation<
  PipelinesTeamDeleteMutation$variables,
  PipelinesTeamDeleteMutation$data,
>*/);
